import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import './assets/main.css'

// 导入路由组件
import Home from './views/Home.vue'
import Register from './views/Register.vue'

import router from './router'

// 创建路由实例
// const router = createRouter({
//   history: createWebHistory(),
//   routes: [
//     {
//       path: '/',
//       name: 'Home',
//       component: Home
//     },
//     {
//       path: '/register',
//       name: 'Register',
//       component: Register
//     }
//   ]
// })

// 创建应用实例
const app = createApp(App)

// 使用路由
app.use(router)

// 挂载应用
app.mount('#app')